import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid } from '../cacheUtils';

export const fetchFeedback = createAsyncThunk(
  'feedback/fetchFeedback',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().feedback;
    if (isCacheValid(state.lastFetched)) {
      return { data: state.data, cached: true };
    }
    try {
      const response = await Axios.get('/api/feedback');
      return { data: response.data.data, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch feedback');
    }
  }
);

export const fetchFeedbackMetrics = createAsyncThunk(
  'feedback/fetchMetrics',
  async (_, { getState, rejectWithValue }) => {
    const state = getState().feedback;
    if (isCacheValid(state.metricsLastFetched)) {
      return { data: state.metrics, cached: true };
    }
    try {
      const response = await Axios.get('/api/feedback/metrics');
      return { data: response.data.data, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch feedback metrics');
    }
  }
);

const feedbackSlice = createSlice({
  name: 'feedback',
  initialState: {
    data: null,
    metrics: null,
    loading: false,
    metricsLoading: false,
    error: null,
    lastFetched: null,
    metricsLastFetched: null,
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = null;
      state.metricsLastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeedback.pending, (state) => {
        if (!state.data) state.loading = true;
      })
      .addCase(fetchFeedback.fulfilled, (state, action) => {
        if (!action.payload.cached) {
          state.data = action.payload.data;
          state.lastFetched = Date.now();
        }
        state.loading = false;
      })
      .addCase(fetchFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchFeedbackMetrics.pending, (state) => {
        if (!state.metrics) state.metricsLoading = true;
      })
      .addCase(fetchFeedbackMetrics.fulfilled, (state, action) => {
        if (!action.payload.cached) {
          state.metrics = action.payload.data;
          state.metricsLastFetched = Date.now();
        }
        state.metricsLoading = false;
      })
      .addCase(fetchFeedbackMetrics.rejected, (state, action) => {
        state.metricsLoading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateFeedbackCache } = feedbackSlice.actions;
export default feedbackSlice.reducer;